
/* injects from baggage-loader */
require('./style.scss');

import React, { useRef, useMemo, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import { getBetBuilderURL, handleBetBuilderUpdateData } from './helpers';

const BetBuilder = ({ sportcastId, oddsFormat, language, skinConfig, updateHandler }) => {
    const iframeRef = useRef();

    const url = useMemo(() => {
        return getBetBuilderURL(sportcastId, oddsFormat, language, skinConfig);
    }, [sportcastId, oddsFormat, language, skinConfig]);

    const onPostMessage = useCallback((event) => {
        if (event.source === iframeRef.current?.contentWindow) {
            const parsedData = JSON.parse(event.data);
            const data = handleBetBuilderUpdateData(parsedData, skinConfig, oddsFormat);
            updateHandler(parsedData.command, data);
        }
    }, [iframeRef, skinConfig, oddsFormat, updateHandler]);
    
    useEffect(() => {
        iframeRef.current && window.addEventListener('message', onPostMessage);
        return () => window.removeEventListener('message', onPostMessage);
    }, [iframeRef, onPostMessage]);

    return <iframe ref={iframeRef} src={url} className="external-bet-builder" />;
};

BetBuilder.propTypes = {
    language: PropTypes.string,
    updateHandler: PropTypes.func,
    oddsFormat: PropTypes.string.isRequired,
    sportcastId: PropTypes.number.isRequired,
    skinConfig: PropTypes.shape({
        url: PropTypes.string.isRequired,
        password: PropTypes.string.isRequired,
        licenseKey: PropTypes.string.isRequired,
        oddsMap: PropTypes.object.isRequired,
        languageMap: PropTypes.object.isRequired,
    }).isRequired,
};

export default BetBuilder;